import React from "react";
import { Form } from "react-bootstrap";
import ReactSelect from "react-select";
import "../modalLayout/commonModal.css";
import useTranslator from "../../../hooks/useTranslator";

const PRIMARY = "#ee7225";
const PRIMARY_LIGHT = "#fff4ee";

const buildStyles = (disabled) => ({
  control: (base, state) => ({
    ...base,
    minHeight: "33.5px",
    fontSize: "14px",
    fontFamily: "'Public Sans', sans-serif",
    borderRadius: "8px",
    borderColor: state.isFocused ? PRIMARY : "#dee2e6",
    boxShadow: state.isFocused ? `0 0 0 1px ${PRIMARY}` : "none",
    backgroundColor: disabled ? "#f8f9fa" : "#ffffff",
    cursor: disabled ? "not-allowed" : "default",
    "&:hover": { borderColor: PRIMARY },
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 12px" }),
  placeholder: (base) => ({ ...base, color: "#9ca3af", fontSize: "14px" }),
  singleValue: (base) => ({ ...base, color: "#212529", fontSize: "14px" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? PRIMARY : "#6c757d",
    "&:hover": { color: PRIMARY },
    padding: "0 10px",
    transition: "color 0.15s ease",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "10px",
    boxShadow: "0 8px 24px rgba(16,24,40,0.12)",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    zIndex: 9999,
  }),
  menuList: (base) => ({ ...base, padding: "4px" }),
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    fontFamily: "'Public Sans', sans-serif",
    borderRadius: "6px",
    backgroundColor: state.isSelected
      ? PRIMARY
      : state.isFocused
      ? PRIMARY_LIGHT
      : "transparent",
    color: state.isSelected ? "#ffffff" : "#212529",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.5 : 1,
    "&:active": { backgroundColor: PRIMARY, color: "#ffffff" },
    padding: "8px 12px",
  }),
});

const SelectBox = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  className = "",
  disabled = false,
}) => {
  const { _t } = useTranslator();

  const selectedOption = options.find((o) => o.value === value) ?? null;

  const handleChange = (option) => {
    if (onChange) {
      onChange({ target: { name, value: option ? option.value : "" } });
    }
  };

  return (
    <Form.Group className={`mb-3 ${className}`}>
      <Form.Label className="cmn_label" column={""}>
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <ReactSelect
        inputId={name}
        name={name}
        value={selectedOption}
        onChange={handleChange}
        options={options}
        isDisabled={disabled}
        placeholder={_t("select_option", "Select an option")}
        styles={buildStyles(disabled)}
        isOptionDisabled={(o) => !!o.disabled}
        menuPosition="fixed"
        classNamePrefix="rsb"
      />
    </Form.Group>
  );
};

export default SelectBox;
